//DIY
import entertainment_singlepiecechess_diy_00001 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00001.png';
import entertainment_singlepiecechess_diy_00002 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00002.png';
import entertainment_singlepiecechess_diy_00003 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00003.png';
import entertainment_singlepiecechess_diy_00004 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00004.png';
import entertainment_singlepiecechess_diy_00005 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00005.png';
import entertainment_singlepiecechess_diy_00006 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00006.png';
import entertainment_singlepiecechess_diy_00007 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00007.png';
import entertainment_singlepiecechess_diy_00008 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_diy_00008.png';
import entertainment_singlepiecechess_emoji_0001_diy from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_emoji_0001_diy.png';
import entertainment_singlepiecechess_emoji_0002_diy from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/entertainment_singlepiecechess_emoji_0002_diy.png';
import entertainment_singlepiecechess_diy_00001_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00001_bl.png';
import entertainment_singlepiecechess_diy_00001_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00001_gn.png';
import entertainment_singlepiecechess_diy_00001_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00001_pu.png';
import entertainment_singlepiecechess_diy_00001_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00001_rd.png';
import entertainment_singlepiecechess_diy_00002_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00002_bl.png';
import entertainment_singlepiecechess_diy_00002_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00002_gn.png';
import entertainment_singlepiecechess_diy_00002_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00002_pu.png';
import entertainment_singlepiecechess_diy_00002_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00002_rd.png';
import entertainment_singlepiecechess_diy_00003_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00003_bl.png';
import entertainment_singlepiecechess_diy_00003_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00003_gn.png';
import entertainment_singlepiecechess_diy_00003_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00003_pu.png';
import entertainment_singlepiecechess_diy_00003_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00003_rd.png';
import entertainment_singlepiecechess_diy_00004_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00004_bl.png';
import entertainment_singlepiecechess_diy_00004_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00004_gn.png';
import entertainment_singlepiecechess_diy_00004_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00004_pu.png';
import entertainment_singlepiecechess_diy_00004_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00004_rd.png';
import entertainment_singlepiecechess_diy_00005_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00005_bl.png';
import entertainment_singlepiecechess_diy_00005_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00005_gn.png';
import entertainment_singlepiecechess_diy_00005_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00005_pu.png';
import entertainment_singlepiecechess_diy_00005_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00005_rd.png';
import entertainment_singlepiecechess_diy_00006_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00006_bl.png';
import entertainment_singlepiecechess_diy_00006_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00006_gn.png';
import entertainment_singlepiecechess_diy_00006_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00006_pu.png';
import entertainment_singlepiecechess_diy_00006_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00006_rd.png';
import entertainment_singlepiecechess_diy_00007_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00007_bl.png';
import entertainment_singlepiecechess_diy_00007_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00007_gn.png';
import entertainment_singlepiecechess_diy_00007_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00007_pu.png';
import entertainment_singlepiecechess_diy_00007_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00007_rd.png';
import entertainment_singlepiecechess_diy_00008_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00008_bl.png';
import entertainment_singlepiecechess_diy_00008_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00008_gn.png';
import entertainment_singlepiecechess_diy_00008_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00008_pu.png';
import entertainment_singlepiecechess_diy_00008_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_diy_00008_rd.png';
import entertainment_singlepiecechess_emoji_0001_diy_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0001_diy_bl.png';
import entertainment_singlepiecechess_emoji_0001_diy_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0001_diy_gn.png';
import entertainment_singlepiecechess_emoji_0001_diy_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0001_diy_pu.png';
import entertainment_singlepiecechess_emoji_0001_diy_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0001_diy_rd.png';
import entertainment_singlepiecechess_emoji_0002_diy_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0002_diy_bl.png';
import entertainment_singlepiecechess_emoji_0002_diy_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0002_diy_gn.png';
import entertainment_singlepiecechess_emoji_0002_diy_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0002_diy_pu.png';
import entertainment_singlepiecechess_emoji_0002_diy_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Diy/fraction/entertainment_singlepiecechess_emoji_0002_diy_rd.png';
//Emoji
import entertainment_singlepiecechess_emoji_0001_01 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_01.png';
import entertainment_singlepiecechess_emoji_0001_02 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_02.png';
import entertainment_singlepiecechess_emoji_0001_03 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_03.png';
import entertainment_singlepiecechess_emoji_0001_04 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_04.png';
import entertainment_singlepiecechess_emoji_0001_05 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_05.png';
import entertainment_singlepiecechess_emoji_0001_06 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_06.png';
import entertainment_singlepiecechess_emoji_0001_07 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_07.png';
import entertainment_singlepiecechess_emoji_0001_08 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_08.png';
import entertainment_singlepiecechess_emoji_0001_09 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_09.png';
import entertainment_singlepiecechess_emoji_0001_10 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_10.png';
import entertainment_singlepiecechess_emoji_0001_11 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_11.png';
import entertainment_singlepiecechess_emoji_0001_12 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0001_12.png';
import entertainment_singlepiecechess_emoji_0002_01 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_01.png';
import entertainment_singlepiecechess_emoji_0002_02 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_02.png';
import entertainment_singlepiecechess_emoji_0002_03 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_03.png';
import entertainment_singlepiecechess_emoji_0002_04 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_04.png';
import entertainment_singlepiecechess_emoji_0002_05 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_05.png';
import entertainment_singlepiecechess_emoji_0002_06 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_06.png';
import entertainment_singlepiecechess_emoji_0002_07 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_07.png';
import entertainment_singlepiecechess_emoji_0002_08 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_08.png';
import entertainment_singlepiecechess_emoji_0002_09 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_09.png';
import entertainment_singlepiecechess_emoji_0002_10 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_10.png';
import entertainment_singlepiecechess_emoji_0002_11 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_11.png';
import entertainment_singlepiecechess_emoji_0002_12 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/entertainment_singlepiecechess_emoji_0002_12.png';
import entertainment_singlepiecechess_emoji_0001_01_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_01_bl.png';
import entertainment_singlepiecechess_emoji_0001_01_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_01_gn.png';
import entertainment_singlepiecechess_emoji_0001_01_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_01_pu.png';
import entertainment_singlepiecechess_emoji_0001_01_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_01_rd.png';
import entertainment_singlepiecechess_emoji_0001_02_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_02_bl.png';
import entertainment_singlepiecechess_emoji_0001_02_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_02_gn.png';
import entertainment_singlepiecechess_emoji_0001_02_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_02_pu.png';
import entertainment_singlepiecechess_emoji_0001_02_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_02_rd.png';
import entertainment_singlepiecechess_emoji_0001_03_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_03_bl.png';
import entertainment_singlepiecechess_emoji_0001_03_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_03_gn.png';
import entertainment_singlepiecechess_emoji_0001_03_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_03_pu.png';
import entertainment_singlepiecechess_emoji_0001_03_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_03_rd.png';
import entertainment_singlepiecechess_emoji_0001_04_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_04_bl.png';
import entertainment_singlepiecechess_emoji_0001_04_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_04_gn.png';
import entertainment_singlepiecechess_emoji_0001_04_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_04_pu.png';
import entertainment_singlepiecechess_emoji_0001_04_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_04_rd.png';
import entertainment_singlepiecechess_emoji_0001_05_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_05_bl.png';
import entertainment_singlepiecechess_emoji_0001_05_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_05_gn.png';
import entertainment_singlepiecechess_emoji_0001_05_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_05_pu.png';
import entertainment_singlepiecechess_emoji_0001_05_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_05_rd.png';
import entertainment_singlepiecechess_emoji_0001_06_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_06_bl.png';
import entertainment_singlepiecechess_emoji_0001_06_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_06_gn.png';
import entertainment_singlepiecechess_emoji_0001_06_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_06_pu.png';
import entertainment_singlepiecechess_emoji_0001_06_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_06_rd.png';
import entertainment_singlepiecechess_emoji_0001_07_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_07_bl.png';
import entertainment_singlepiecechess_emoji_0001_07_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_07_gn.png';
import entertainment_singlepiecechess_emoji_0001_07_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_07_pu.png';
import entertainment_singlepiecechess_emoji_0001_07_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_07_rd.png';
import entertainment_singlepiecechess_emoji_0001_08_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_08_bl.png';
import entertainment_singlepiecechess_emoji_0001_08_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_08_gn.png';
import entertainment_singlepiecechess_emoji_0001_08_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_08_pu.png';
import entertainment_singlepiecechess_emoji_0001_08_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_08_rd.png';
import entertainment_singlepiecechess_emoji_0001_09_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_09_bl.png';
import entertainment_singlepiecechess_emoji_0001_09_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_09_gn.png';
import entertainment_singlepiecechess_emoji_0001_09_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_09_pu.png';
import entertainment_singlepiecechess_emoji_0001_09_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_09_rd.png';
import entertainment_singlepiecechess_emoji_0001_10_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_10_bl.png';
import entertainment_singlepiecechess_emoji_0001_10_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_10_gn.png';
import entertainment_singlepiecechess_emoji_0001_10_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_10_pu.png';
import entertainment_singlepiecechess_emoji_0001_10_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_10_rd.png';
import entertainment_singlepiecechess_emoji_0001_11_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_11_bl.png';
import entertainment_singlepiecechess_emoji_0001_11_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_11_gn.png';
import entertainment_singlepiecechess_emoji_0001_11_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_11_pu.png';
import entertainment_singlepiecechess_emoji_0001_11_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_11_rd.png';
import entertainment_singlepiecechess_emoji_0001_12_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_12_bl.png';
import entertainment_singlepiecechess_emoji_0001_12_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_12_gn.png';
import entertainment_singlepiecechess_emoji_0001_12_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_12_pu.png';
import entertainment_singlepiecechess_emoji_0001_12_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0001_12_rd.png';
import entertainment_singlepiecechess_emoji_0002_01_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_01_bl.png';
import entertainment_singlepiecechess_emoji_0002_01_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_01_gn.png';
import entertainment_singlepiecechess_emoji_0002_01_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_01_pu.png';
import entertainment_singlepiecechess_emoji_0002_01_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_01_rd.png';
import entertainment_singlepiecechess_emoji_0002_02_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_02_bl.png';
import entertainment_singlepiecechess_emoji_0002_02_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_02_gn.png';
import entertainment_singlepiecechess_emoji_0002_02_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_02_pu.png';
import entertainment_singlepiecechess_emoji_0002_02_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_02_rd.png';
import entertainment_singlepiecechess_emoji_0002_03_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_03_bl.png';
import entertainment_singlepiecechess_emoji_0002_03_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_03_gn.png';
import entertainment_singlepiecechess_emoji_0002_03_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_03_pu.png';
import entertainment_singlepiecechess_emoji_0002_03_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_03_rd.png';
import entertainment_singlepiecechess_emoji_0002_04_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_04_bl.png';
import entertainment_singlepiecechess_emoji_0002_04_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_04_gn.png';
import entertainment_singlepiecechess_emoji_0002_04_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_04_pu.png';
import entertainment_singlepiecechess_emoji_0002_04_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_04_rd.png';
import entertainment_singlepiecechess_emoji_0002_05_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_05_bl.png';
import entertainment_singlepiecechess_emoji_0002_05_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_05_gn.png';
import entertainment_singlepiecechess_emoji_0002_05_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_05_pu.png';
import entertainment_singlepiecechess_emoji_0002_05_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_05_rd.png';
import entertainment_singlepiecechess_emoji_0002_06_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_06_bl.png';
import entertainment_singlepiecechess_emoji_0002_06_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_06_gn.png';
import entertainment_singlepiecechess_emoji_0002_06_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_06_pu.png';
import entertainment_singlepiecechess_emoji_0002_06_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_06_rd.png';
import entertainment_singlepiecechess_emoji_0002_07_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_07_bl.png';
import entertainment_singlepiecechess_emoji_0002_07_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_07_gn.png';
import entertainment_singlepiecechess_emoji_0002_07_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_07_pu.png';
import entertainment_singlepiecechess_emoji_0002_07_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_07_rd.png';
import entertainment_singlepiecechess_emoji_0002_08_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_08_bl.png';
import entertainment_singlepiecechess_emoji_0002_08_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_08_gn.png';
import entertainment_singlepiecechess_emoji_0002_08_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_08_pu.png';
import entertainment_singlepiecechess_emoji_0002_08_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_08_rd.png';
import entertainment_singlepiecechess_emoji_0002_09_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_09_bl.png';
import entertainment_singlepiecechess_emoji_0002_09_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_09_gn.png';
import entertainment_singlepiecechess_emoji_0002_09_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_09_pu.png';
import entertainment_singlepiecechess_emoji_0002_09_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_09_rd.png';
import entertainment_singlepiecechess_emoji_0002_10_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_10_bl.png';
import entertainment_singlepiecechess_emoji_0002_10_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_10_gn.png';
import entertainment_singlepiecechess_emoji_0002_10_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_10_pu.png';
import entertainment_singlepiecechess_emoji_0002_10_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_10_rd.png';
import entertainment_singlepiecechess_emoji_0002_11_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_11_bl.png';
import entertainment_singlepiecechess_emoji_0002_11_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_11_gn.png';
import entertainment_singlepiecechess_emoji_0002_11_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_11_pu.png';
import entertainment_singlepiecechess_emoji_0002_11_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_11_rd.png';
import entertainment_singlepiecechess_emoji_0002_12_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_12_bl.png';
import entertainment_singlepiecechess_emoji_0002_12_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_12_gn.png';
import entertainment_singlepiecechess_emoji_0002_12_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_12_pu.png';
import entertainment_singlepiecechess_emoji_0002_12_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Emoji/fraction/entertainment_singlepiecechess_emoji_0002_12_rd.png';
//Letter entertainment_singlepiecechess_loweralphabet_(\s+)
import entertainment_singlepiecechess_loweralphabet_a from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_a.png';
import entertainment_singlepiecechess_loweralphabet_b from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_b.png';
import entertainment_singlepiecechess_loweralphabet_c from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_c.png';
import entertainment_singlepiecechess_loweralphabet_d from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_d.png';
import entertainment_singlepiecechess_loweralphabet_e from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_e.png';
import entertainment_singlepiecechess_loweralphabet_f from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_f.png';
import entertainment_singlepiecechess_loweralphabet_g from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_g.png';
import entertainment_singlepiecechess_loweralphabet_h from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_h.png';
import entertainment_singlepiecechess_loweralphabet_i from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_i.png';
import entertainment_singlepiecechess_loweralphabet_j from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_j.png';
import entertainment_singlepiecechess_loweralphabet_k from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_k.png';
import entertainment_singlepiecechess_loweralphabet_l from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_l.png';
import entertainment_singlepiecechess_loweralphabet_m from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_m.png';
import entertainment_singlepiecechess_loweralphabet_n from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_n.png';
import entertainment_singlepiecechess_loweralphabet_o from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_o.png';
import entertainment_singlepiecechess_loweralphabet_p from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_p.png';
import entertainment_singlepiecechess_loweralphabet_q from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_q.png';
import entertainment_singlepiecechess_loweralphabet_r from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_r.png';
import entertainment_singlepiecechess_loweralphabet_s from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_s.png';
import entertainment_singlepiecechess_loweralphabet_t from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_t.png';
import entertainment_singlepiecechess_loweralphabet_u from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_u.png';
import entertainment_singlepiecechess_loweralphabet_v from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_v.png';
import entertainment_singlepiecechess_loweralphabet_w from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_w.png';
import entertainment_singlepiecechess_loweralphabet_x from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_x.png';
import entertainment_singlepiecechess_loweralphabet_y from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_y.png';
import entertainment_singlepiecechess_loweralphabet_z from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_loweralphabet_z.png';
import entertainment_singlepiecechess_number_0 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_0.png';
import entertainment_singlepiecechess_number_1 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_1.png';
import entertainment_singlepiecechess_number_2 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_2.png';
import entertainment_singlepiecechess_number_3 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_3.png';
import entertainment_singlepiecechess_number_4 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_4.png';
import entertainment_singlepiecechess_number_5 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_5.png';
import entertainment_singlepiecechess_number_6 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_6.png';
import entertainment_singlepiecechess_number_7 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_7.png';
import entertainment_singlepiecechess_number_8 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_8.png';
import entertainment_singlepiecechess_number_9 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_number_9.png';
import entertainment_singlepiecechess_symbol_001 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_001.png';
import entertainment_singlepiecechess_symbol_002 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_002.png';
import entertainment_singlepiecechess_symbol_003 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_003.png';
import entertainment_singlepiecechess_symbol_004 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_004.png';
import entertainment_singlepiecechess_symbol_005 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_005.png';
import entertainment_singlepiecechess_symbol_006 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_006.png';
import entertainment_singlepiecechess_symbol_007 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_007.png';
import entertainment_singlepiecechess_symbol_008 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_008.png';
import entertainment_singlepiecechess_symbol_009 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_009.png';
import entertainment_singlepiecechess_symbol_010 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_010.png';
import entertainment_singlepiecechess_symbol_011 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_011.png';
import entertainment_singlepiecechess_symbol_012 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_012.png';
import entertainment_singlepiecechess_symbol_013 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_symbol_013.png';
import entertainment_singlepiecechess_upperalphabet_a from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_a.png';
import entertainment_singlepiecechess_upperalphabet_b from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_b.png';
import entertainment_singlepiecechess_upperalphabet_c from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_c.png';
import entertainment_singlepiecechess_upperalphabet_d from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_d.png';
import entertainment_singlepiecechess_upperalphabet_e from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_e.png';
import entertainment_singlepiecechess_upperalphabet_f from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_f.png';
import entertainment_singlepiecechess_upperalphabet_g from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_g.png';
import entertainment_singlepiecechess_upperalphabet_h from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_h.png';
import entertainment_singlepiecechess_upperalphabet_i from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_i.png';
import entertainment_singlepiecechess_upperalphabet_j from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_j.png';
import entertainment_singlepiecechess_upperalphabet_k from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_k.png';
import entertainment_singlepiecechess_upperalphabet_l from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_l.png';
import entertainment_singlepiecechess_upperalphabet_m from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_m.png';
import entertainment_singlepiecechess_upperalphabet_n from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_n.png';
import entertainment_singlepiecechess_upperalphabet_o from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_o.png';
import entertainment_singlepiecechess_upperalphabet_p from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_p.png';
import entertainment_singlepiecechess_upperalphabet_q from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_q.png';
import entertainment_singlepiecechess_upperalphabet_r from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_r.png';
import entertainment_singlepiecechess_upperalphabet_s from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_s.png';
import entertainment_singlepiecechess_upperalphabet_t from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_t.png';
import entertainment_singlepiecechess_upperalphabet_u from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_u.png';
import entertainment_singlepiecechess_upperalphabet_v from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_v.png';
import entertainment_singlepiecechess_upperalphabet_w from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_w.png';
import entertainment_singlepiecechess_upperalphabet_x from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_x.png';
import entertainment_singlepiecechess_upperalphabet_y from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_y.png';
import entertainment_singlepiecechess_upperalphabet_z from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Letter/entertainment_singlepiecechess_upperalphabet_z.png';
//Others
import entertainment_singlepiecechess_00001 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00001.png';
import entertainment_singlepiecechess_00002 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00002.png';
import entertainment_singlepiecechess_00003 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00003.png';
import entertainment_singlepiecechess_00004 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00004.png';
import entertainment_singlepiecechess_00005 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00005.png';
import entertainment_singlepiecechess_00006 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00006.png';
import entertainment_singlepiecechess_00007 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00007.png';
import entertainment_singlepiecechess_00008 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00008.png';
import entertainment_singlepiecechess_00009 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00009.png';
import entertainment_singlepiecechess_00010 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00010.png';
import entertainment_singlepiecechess_00011 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00011.png';
import entertainment_singlepiecechess_00012 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00012.png';
import entertainment_singlepiecechess_00013 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00013.png';
import entertainment_singlepiecechess_00014 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00014.png';
import entertainment_singlepiecechess_00015 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00015.png';
import entertainment_singlepiecechess_00016 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00016.png';
import entertainment_singlepiecechess_00017 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00017.png';
import entertainment_singlepiecechess_00018 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00018.png';
import entertainment_singlepiecechess_00019 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00019.png';
import entertainment_singlepiecechess_00020 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00020.png';
import entertainment_singlepiecechess_00021 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00021.png';
import entertainment_singlepiecechess_00022 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00022.png';
import entertainment_singlepiecechess_00023 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00023.png';
import entertainment_singlepiecechess_00024 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00024.png';
import entertainment_singlepiecechess_00025 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00025.png';
import entertainment_singlepiecechess_00026 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00026.png';
import entertainment_singlepiecechess_00027 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00027.png';
import entertainment_singlepiecechess_00028 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00028.png';
import entertainment_singlepiecechess_00029 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00029.png';
import entertainment_singlepiecechess_00030 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00030.png';
import entertainment_singlepiecechess_00031 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00031.png';
import entertainment_singlepiecechess_00032 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00032.png';
import entertainment_singlepiecechess_00033 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00033.png';
import entertainment_singlepiecechess_00034 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00034.png';
import entertainment_singlepiecechess_00035 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00035.png';
import entertainment_singlepiecechess_00036 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00036.png';
import entertainment_singlepiecechess_00037 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00037.png';
import entertainment_singlepiecechess_00038 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00038.png';
import entertainment_singlepiecechess_00039 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00039.png';
import entertainment_singlepiecechess_00040 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00040.png';
import entertainment_singlepiecechess_00041 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00041.png';
import entertainment_singlepiecechess_00042 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00042.png';
import entertainment_singlepiecechess_00043 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00043.png';
import entertainment_singlepiecechess_00044 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00044.png';
import entertainment_singlepiecechess_00045 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00045.png';
import entertainment_singlepiecechess_00046 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00046.png';
import entertainment_singlepiecechess_00047 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00047.png';
import entertainment_singlepiecechess_00048 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00048.png';
import entertainment_singlepiecechess_00049 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00049.png';
import entertainment_singlepiecechess_00050 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00050.png';
import entertainment_singlepiecechess_00051 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00051.png';
import entertainment_singlepiecechess_00052 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00052.png';
import entertainment_singlepiecechess_00053 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00053.png';
import entertainment_singlepiecechess_00054 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00054.png';
import entertainment_singlepiecechess_00055 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00055.png';
import entertainment_singlepiecechess_00056 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00056.png';
import entertainment_singlepiecechess_00057 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00057.png';
import entertainment_singlepiecechess_00058 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00058.png';
import entertainment_singlepiecechess_00059 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00059.png';
import entertainment_singlepiecechess_00060 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00060.png';
import entertainment_singlepiecechess_00061 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00061.png';
import entertainment_singlepiecechess_00062 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00062.png';
import entertainment_singlepiecechess_00063 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00063.png';
import entertainment_singlepiecechess_00064 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00064.png';
import entertainment_singlepiecechess_00065 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00065.png';
import entertainment_singlepiecechess_00066 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00066.png';
import entertainment_singlepiecechess_00067 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00067.png';
import entertainment_singlepiecechess_00068 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00068.png';
import entertainment_singlepiecechess_00069 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00069.png';
import entertainment_singlepiecechess_00070 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00070.png';
import entertainment_singlepiecechess_00071 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00071.png';
import entertainment_singlepiecechess_00072 from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/entertainment_singlepiecechess_00072.png';
import entertainment_singlepiecechess_00001_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00001_bl.png';
import entertainment_singlepiecechess_00001_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00001_gn.png';
import entertainment_singlepiecechess_00001_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00001_pu.png';
import entertainment_singlepiecechess_00001_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00001_rd.png';
import entertainment_singlepiecechess_00002_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00002_bl.png';
import entertainment_singlepiecechess_00002_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00002_gn.png';
import entertainment_singlepiecechess_00002_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00002_pu.png';
import entertainment_singlepiecechess_00002_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00002_rd.png';
import entertainment_singlepiecechess_00003_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00003_bl.png';
import entertainment_singlepiecechess_00003_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00003_gn.png';
import entertainment_singlepiecechess_00003_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00003_pu.png';
import entertainment_singlepiecechess_00003_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00003_rd.png';
import entertainment_singlepiecechess_00004_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00004_bl.png';
import entertainment_singlepiecechess_00004_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00004_gn.png';
import entertainment_singlepiecechess_00004_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00004_pu.png';
import entertainment_singlepiecechess_00004_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00004_rd.png';
import entertainment_singlepiecechess_00005_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00005_bl.png';
import entertainment_singlepiecechess_00005_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00005_gn.png';
import entertainment_singlepiecechess_00005_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00005_pu.png';
import entertainment_singlepiecechess_00005_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00005_rd.png';
import entertainment_singlepiecechess_00006_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00006_bl.png';
import entertainment_singlepiecechess_00006_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00006_gn.png';
import entertainment_singlepiecechess_00006_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00006_pu.png';
import entertainment_singlepiecechess_00006_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00006_rd.png';
import entertainment_singlepiecechess_00007_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00007_bl.png';
import entertainment_singlepiecechess_00007_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00007_gn.png';
import entertainment_singlepiecechess_00007_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00007_pu.png';
import entertainment_singlepiecechess_00007_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00007_rd.png';
import entertainment_singlepiecechess_00008_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00008_bl.png';
import entertainment_singlepiecechess_00008_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00008_gn.png';
import entertainment_singlepiecechess_00008_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00008_pu.png';
import entertainment_singlepiecechess_00008_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00008_rd.png';
import entertainment_singlepiecechess_00009_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00009_bl.png';
import entertainment_singlepiecechess_00009_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00009_gn.png';
import entertainment_singlepiecechess_00009_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00009_pu.png';
import entertainment_singlepiecechess_00009_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00009_rd.png';
import entertainment_singlepiecechess_00010_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00010_bl.png';
import entertainment_singlepiecechess_00010_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00010_gn.png';
import entertainment_singlepiecechess_00010_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00010_pu.png';
import entertainment_singlepiecechess_00010_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00010_rd.png';
import entertainment_singlepiecechess_00011_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00011_bl.png';
import entertainment_singlepiecechess_00011_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00011_gn.png';
import entertainment_singlepiecechess_00011_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00011_pu.png';
import entertainment_singlepiecechess_00011_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00011_rd.png';
import entertainment_singlepiecechess_00012_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00012_bl.png';
import entertainment_singlepiecechess_00012_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00012_gn.png';
import entertainment_singlepiecechess_00012_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00012_pu.png';
import entertainment_singlepiecechess_00012_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00012_rd.png';
import entertainment_singlepiecechess_00013_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00013_bl.png';
import entertainment_singlepiecechess_00013_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00013_gn.png';
import entertainment_singlepiecechess_00013_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00013_pu.png';
import entertainment_singlepiecechess_00013_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00013_rd.png';
import entertainment_singlepiecechess_00014_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00014_bl.png';
import entertainment_singlepiecechess_00014_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00014_gn.png';
import entertainment_singlepiecechess_00014_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00014_pu.png';
import entertainment_singlepiecechess_00014_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00014_rd.png';
import entertainment_singlepiecechess_00015_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00015_bl.png';
import entertainment_singlepiecechess_00015_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00015_gn.png';
import entertainment_singlepiecechess_00015_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00015_pu.png';
import entertainment_singlepiecechess_00015_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00015_rd.png';
import entertainment_singlepiecechess_00016_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00016_bl.png';
import entertainment_singlepiecechess_00016_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00016_gn.png';
import entertainment_singlepiecechess_00016_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00016_pu.png';
import entertainment_singlepiecechess_00016_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00016_rd.png';
import entertainment_singlepiecechess_00017_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00017_bl.png';
import entertainment_singlepiecechess_00017_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00017_gn.png';
import entertainment_singlepiecechess_00017_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00017_pu.png';
import entertainment_singlepiecechess_00017_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00017_rd.png';
import entertainment_singlepiecechess_00018_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00018_bl.png';
import entertainment_singlepiecechess_00018_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00018_gn.png';
import entertainment_singlepiecechess_00018_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00018_pu.png';
import entertainment_singlepiecechess_00018_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00018_rd.png';
import entertainment_singlepiecechess_00019_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00019_bl.png';
import entertainment_singlepiecechess_00019_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00019_gn.png';
import entertainment_singlepiecechess_00019_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00019_pu.png';
import entertainment_singlepiecechess_00019_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00019_rd.png';
import entertainment_singlepiecechess_00020_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00020_bl.png';
import entertainment_singlepiecechess_00020_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00020_gn.png';
import entertainment_singlepiecechess_00020_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00020_pu.png';
import entertainment_singlepiecechess_00020_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00020_rd.png';
import entertainment_singlepiecechess_00021_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00021_bl.png';
import entertainment_singlepiecechess_00021_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00021_gn.png';
import entertainment_singlepiecechess_00021_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00021_pu.png';
import entertainment_singlepiecechess_00021_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00021_rd.png';
import entertainment_singlepiecechess_00022_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00022_bl.png';
import entertainment_singlepiecechess_00022_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00022_gn.png';
import entertainment_singlepiecechess_00022_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00022_pu.png';
import entertainment_singlepiecechess_00022_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00022_rd.png';
import entertainment_singlepiecechess_00023_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00023_bl.png';
import entertainment_singlepiecechess_00023_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00023_gn.png';
import entertainment_singlepiecechess_00023_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00023_pu.png';
import entertainment_singlepiecechess_00023_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00023_rd.png';
import entertainment_singlepiecechess_00024_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00024_bl.png';
import entertainment_singlepiecechess_00024_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00024_gn.png';
import entertainment_singlepiecechess_00024_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00024_pu.png';
import entertainment_singlepiecechess_00024_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00024_rd.png';
import entertainment_singlepiecechess_00025_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00025_bl.png';
import entertainment_singlepiecechess_00025_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00025_gn.png';
import entertainment_singlepiecechess_00025_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00025_pu.png';
import entertainment_singlepiecechess_00025_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00025_rd.png';
import entertainment_singlepiecechess_00026_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00026_bl.png';
import entertainment_singlepiecechess_00026_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00026_gn.png';
import entertainment_singlepiecechess_00026_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00026_pu.png';
import entertainment_singlepiecechess_00026_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00026_rd.png';
import entertainment_singlepiecechess_00027_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00027_bl.png';
import entertainment_singlepiecechess_00027_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00027_gn.png';
import entertainment_singlepiecechess_00027_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00027_pu.png';
import entertainment_singlepiecechess_00027_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00027_rd.png';
import entertainment_singlepiecechess_00028_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00028_bl.png';
import entertainment_singlepiecechess_00028_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00028_gn.png';
import entertainment_singlepiecechess_00028_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00028_pu.png';
import entertainment_singlepiecechess_00028_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00028_rd.png';
import entertainment_singlepiecechess_00029_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00029_bl.png';
import entertainment_singlepiecechess_00029_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00029_gn.png';
import entertainment_singlepiecechess_00029_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00029_pu.png';
import entertainment_singlepiecechess_00029_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00029_rd.png';
import entertainment_singlepiecechess_00030_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00030_bl.png';
import entertainment_singlepiecechess_00030_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00030_gn.png';
import entertainment_singlepiecechess_00030_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00030_pu.png';
import entertainment_singlepiecechess_00030_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00030_rd.png';
import entertainment_singlepiecechess_00031_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00031_bl.png';
import entertainment_singlepiecechess_00031_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00031_gn.png';
import entertainment_singlepiecechess_00031_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00031_pu.png';
import entertainment_singlepiecechess_00031_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00031_rd.png';
import entertainment_singlepiecechess_00032_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00032_bl.png';
import entertainment_singlepiecechess_00032_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00032_gn.png';
import entertainment_singlepiecechess_00032_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00032_pu.png';
import entertainment_singlepiecechess_00032_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00032_rd.png';
import entertainment_singlepiecechess_00033_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00033_bl.png';
import entertainment_singlepiecechess_00033_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00033_gn.png';
import entertainment_singlepiecechess_00033_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00033_pu.png';
import entertainment_singlepiecechess_00033_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00033_rd.png';
import entertainment_singlepiecechess_00034_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00034_bl.png';
import entertainment_singlepiecechess_00034_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00034_gn.png';
import entertainment_singlepiecechess_00034_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00034_pu.png';
import entertainment_singlepiecechess_00034_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00034_rd.png';
import entertainment_singlepiecechess_00035_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00035_bl.png';
import entertainment_singlepiecechess_00035_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00035_gn.png';
import entertainment_singlepiecechess_00035_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00035_pu.png';
import entertainment_singlepiecechess_00035_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00035_rd.png';
import entertainment_singlepiecechess_00036_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00036_bl.png';
import entertainment_singlepiecechess_00036_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00036_gn.png';
import entertainment_singlepiecechess_00036_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00036_pu.png';
import entertainment_singlepiecechess_00036_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00036_rd.png';
import entertainment_singlepiecechess_00037_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00037_bl.png';
import entertainment_singlepiecechess_00037_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00037_gn.png';
import entertainment_singlepiecechess_00037_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00037_pu.png';
import entertainment_singlepiecechess_00037_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00037_rd.png';
import entertainment_singlepiecechess_00038_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00038_bl.png';
import entertainment_singlepiecechess_00038_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00038_gn.png';
import entertainment_singlepiecechess_00038_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00038_pu.png';
import entertainment_singlepiecechess_00038_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00038_rd.png';
import entertainment_singlepiecechess_00039_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00039_bl.png';
import entertainment_singlepiecechess_00039_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00039_gn.png';
import entertainment_singlepiecechess_00039_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00039_pu.png';
import entertainment_singlepiecechess_00039_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00039_rd.png';
import entertainment_singlepiecechess_00040_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00040_bl.png';
import entertainment_singlepiecechess_00040_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00040_gn.png';
import entertainment_singlepiecechess_00040_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00040_pu.png';
import entertainment_singlepiecechess_00040_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00040_rd.png';
import entertainment_singlepiecechess_00041_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00041_bl.png';
import entertainment_singlepiecechess_00041_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00041_gn.png';
import entertainment_singlepiecechess_00041_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00041_pu.png';
import entertainment_singlepiecechess_00041_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00041_rd.png';
import entertainment_singlepiecechess_00042_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00042_bl.png';
import entertainment_singlepiecechess_00042_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00042_gn.png';
import entertainment_singlepiecechess_00042_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00042_pu.png';
import entertainment_singlepiecechess_00042_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00042_rd.png';
import entertainment_singlepiecechess_00043_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00043_bl.png';
import entertainment_singlepiecechess_00043_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00043_gn.png';
import entertainment_singlepiecechess_00043_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00043_pu.png';
import entertainment_singlepiecechess_00043_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00043_rd.png';
import entertainment_singlepiecechess_00044_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00044_bl.png';
import entertainment_singlepiecechess_00044_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00044_gn.png';
import entertainment_singlepiecechess_00044_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00044_pu.png';
import entertainment_singlepiecechess_00044_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00044_rd.png';
import entertainment_singlepiecechess_00045_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00045_bl.png';
import entertainment_singlepiecechess_00045_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00045_gn.png';
import entertainment_singlepiecechess_00045_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00045_pu.png';
import entertainment_singlepiecechess_00045_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00045_rd.png';
import entertainment_singlepiecechess_00046_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00046_bl.png';
import entertainment_singlepiecechess_00046_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00046_gn.png';
import entertainment_singlepiecechess_00046_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00046_pu.png';
import entertainment_singlepiecechess_00046_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00046_rd.png';
import entertainment_singlepiecechess_00047_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00047_bl.png';
import entertainment_singlepiecechess_00047_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00047_gn.png';
import entertainment_singlepiecechess_00047_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00047_pu.png';
import entertainment_singlepiecechess_00047_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00047_rd.png';
import entertainment_singlepiecechess_00048_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00048_bl.png';
import entertainment_singlepiecechess_00048_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00048_gn.png';
import entertainment_singlepiecechess_00048_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00048_pu.png';
import entertainment_singlepiecechess_00048_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00048_rd.png';
import entertainment_singlepiecechess_00049_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00049_bl.png';
import entertainment_singlepiecechess_00049_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00049_gn.png';
import entertainment_singlepiecechess_00049_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00049_pu.png';
import entertainment_singlepiecechess_00049_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00049_rd.png';
import entertainment_singlepiecechess_00050_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00050_bl.png';
import entertainment_singlepiecechess_00050_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00050_gn.png';
import entertainment_singlepiecechess_00050_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00050_pu.png';
import entertainment_singlepiecechess_00050_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00050_rd.png';
import entertainment_singlepiecechess_00051_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00051_bl.png';
import entertainment_singlepiecechess_00051_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00051_gn.png';
import entertainment_singlepiecechess_00051_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00051_pu.png';
import entertainment_singlepiecechess_00051_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00051_rd.png';
import entertainment_singlepiecechess_00052_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00052_bl.png';
import entertainment_singlepiecechess_00052_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00052_gn.png';
import entertainment_singlepiecechess_00052_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00052_pu.png';
import entertainment_singlepiecechess_00052_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00052_rd.png';
import entertainment_singlepiecechess_00053_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00053_bl.png';
import entertainment_singlepiecechess_00053_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00053_gn.png';
import entertainment_singlepiecechess_00053_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00053_pu.png';
import entertainment_singlepiecechess_00053_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00053_rd.png';
import entertainment_singlepiecechess_00054_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00054_bl.png';
import entertainment_singlepiecechess_00054_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00054_gn.png';
import entertainment_singlepiecechess_00054_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00054_pu.png';
import entertainment_singlepiecechess_00054_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00054_rd.png';
import entertainment_singlepiecechess_00055_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00055_bl.png';
import entertainment_singlepiecechess_00055_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00055_gn.png';
import entertainment_singlepiecechess_00055_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00055_pu.png';
import entertainment_singlepiecechess_00055_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00055_rd.png';
import entertainment_singlepiecechess_00056_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00056_bl.png';
import entertainment_singlepiecechess_00056_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00056_gn.png';
import entertainment_singlepiecechess_00056_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00056_pu.png';
import entertainment_singlepiecechess_00056_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00056_rd.png';
import entertainment_singlepiecechess_00057_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00057_bl.png';
import entertainment_singlepiecechess_00057_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00057_gn.png';
import entertainment_singlepiecechess_00057_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00057_pu.png';
import entertainment_singlepiecechess_00057_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00057_rd.png';
import entertainment_singlepiecechess_00058_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00058_bl.png';
import entertainment_singlepiecechess_00058_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00058_gn.png';
import entertainment_singlepiecechess_00058_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00058_pu.png';
import entertainment_singlepiecechess_00058_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00058_rd.png';
import entertainment_singlepiecechess_00059_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00059_bl.png';
import entertainment_singlepiecechess_00059_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00059_gn.png';
import entertainment_singlepiecechess_00059_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00059_pu.png';
import entertainment_singlepiecechess_00059_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00059_rd.png';
import entertainment_singlepiecechess_00060_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00060_bl.png';
import entertainment_singlepiecechess_00060_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00060_gn.png';
import entertainment_singlepiecechess_00060_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00060_pu.png';
import entertainment_singlepiecechess_00060_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00060_rd.png';
import entertainment_singlepiecechess_00061_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00061_bl.png';
import entertainment_singlepiecechess_00061_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00061_gn.png';
import entertainment_singlepiecechess_00061_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00061_pu.png';
import entertainment_singlepiecechess_00061_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00061_rd.png';
import entertainment_singlepiecechess_00062_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00062_bl.png';
import entertainment_singlepiecechess_00062_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00062_gn.png';
import entertainment_singlepiecechess_00062_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00062_pu.png';
import entertainment_singlepiecechess_00062_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00062_rd.png';
import entertainment_singlepiecechess_00063_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00063_bl.png';
import entertainment_singlepiecechess_00063_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00063_gn.png';
import entertainment_singlepiecechess_00063_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00063_pu.png';
import entertainment_singlepiecechess_00063_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00063_rd.png';
import entertainment_singlepiecechess_00064_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00064_bl.png';
import entertainment_singlepiecechess_00064_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00064_gn.png';
import entertainment_singlepiecechess_00064_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00064_pu.png';
import entertainment_singlepiecechess_00064_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00064_rd.png';
import entertainment_singlepiecechess_00065_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00065_bl.png';
import entertainment_singlepiecechess_00065_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00065_gn.png';
import entertainment_singlepiecechess_00065_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00065_pu.png';
import entertainment_singlepiecechess_00065_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00065_rd.png';
import entertainment_singlepiecechess_00066_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00066_bl.png';
import entertainment_singlepiecechess_00066_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00066_gn.png';
import entertainment_singlepiecechess_00066_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00066_pu.png';
import entertainment_singlepiecechess_00066_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00066_rd.png';
import entertainment_singlepiecechess_00067_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00067_bl.png';
import entertainment_singlepiecechess_00067_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00067_gn.png';
import entertainment_singlepiecechess_00067_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00067_pu.png';
import entertainment_singlepiecechess_00067_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00067_rd.png';
import entertainment_singlepiecechess_00068_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00068_bl.png';
import entertainment_singlepiecechess_00068_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00068_gn.png';
import entertainment_singlepiecechess_00068_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00068_pu.png';
import entertainment_singlepiecechess_00068_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00068_rd.png';
import entertainment_singlepiecechess_00069_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00069_bl.png';
import entertainment_singlepiecechess_00069_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00069_gn.png';
import entertainment_singlepiecechess_00069_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00069_pu.png';
import entertainment_singlepiecechess_00069_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00069_rd.png';
import entertainment_singlepiecechess_00070_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00070_bl.png';
import entertainment_singlepiecechess_00070_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00070_gn.png';
import entertainment_singlepiecechess_00070_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00070_pu.png';
import entertainment_singlepiecechess_00070_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00070_rd.png';
import entertainment_singlepiecechess_00071_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00071_bl.png';
import entertainment_singlepiecechess_00071_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00071_gn.png';
import entertainment_singlepiecechess_00071_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00071_pu.png';
import entertainment_singlepiecechess_00071_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00071_rd.png';
import entertainment_singlepiecechess_00072_bl from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00072_bl.png';
import entertainment_singlepiecechess_00072_gn from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00072_gn.png';
import entertainment_singlepiecechess_00072_pu from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00072_pu.png';
import entertainment_singlepiecechess_00072_rd from '../../assets/graphics/png/entertainment_games/JoyachessPiece/Others/fraction/entertainment_singlepiecechess_00072_rd.png';

import { GameFactionSide } from './gameFaction';
import { JoyachessItemNo } from './joyachessItemNo';

// Define the interface for the chess item
interface ChessItem {
  itemId: JoyachessItemNo;
  isVisible: boolean;
  visual: {
    filePrefix: string;
    hasThumbnail: boolean;
    hasMask: boolean;
    hasHighlight: boolean;
    faction?: Partial<Record<GameFactionSide, string>>;
  };
  strokeColor?: string;
}

export const joyachessMaps: { [key in JoyachessItemNo]: ChessItem } = {
  [JoyachessItemNo.item1]: {
    itemId: JoyachessItemNo.item1,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_a,
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item2]: {
    itemId: JoyachessItemNo.item2,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_a,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item3]: {
    itemId: JoyachessItemNo.item3,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_b,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item4]: {
    itemId: JoyachessItemNo.item4,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_c,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item5]: {
    itemId: JoyachessItemNo.item5,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_d,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item6]: {
    itemId: JoyachessItemNo.item6,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_e,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item7]: {
    itemId: JoyachessItemNo.item7,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_f,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item8]: {
    itemId: JoyachessItemNo.item8,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_g,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item9]: {
    itemId: JoyachessItemNo.item9,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_h,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item10]: {
    itemId: JoyachessItemNo.item10,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_i,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item11]: {
    itemId: JoyachessItemNo.item11,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_j,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item12]: {
    itemId: JoyachessItemNo.item12,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_k,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item13]: {
    itemId: JoyachessItemNo.item13,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_l,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item14]: {
    itemId: JoyachessItemNo.item14,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_m,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item15]: {
    itemId: JoyachessItemNo.item15,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_n,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item16]: {
    itemId: JoyachessItemNo.item16,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_o,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item17]: {
    itemId: JoyachessItemNo.item17,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_p,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item18]: {
    itemId: JoyachessItemNo.item18,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_q,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item19]: {
    itemId: JoyachessItemNo.item19,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_r,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item20]: {
    itemId: JoyachessItemNo.item20,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_s,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item21]: {
    itemId: JoyachessItemNo.item21,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_t,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item22]: {
    itemId: JoyachessItemNo.item22,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_u,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item23]: {
    itemId: JoyachessItemNo.item23,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_v,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item24]: {
    itemId: JoyachessItemNo.item24,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_w,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item25]: {
    itemId: JoyachessItemNo.item25,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_x,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item26]: {
    itemId: JoyachessItemNo.item26,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_y,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item27]: {
    itemId: JoyachessItemNo.item27,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_loweralphabet_z,

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item28]: {
    itemId: JoyachessItemNo.item28,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_a,
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item29]: {
    itemId: JoyachessItemNo.item29,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_a,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item30]: {
    itemId: JoyachessItemNo.item30,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_b,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item31]: {
    itemId: JoyachessItemNo.item31,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_c,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item32]: {
    itemId: JoyachessItemNo.item32,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_d,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item33]: {
    itemId: JoyachessItemNo.item33,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_e,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item34]: {
    itemId: JoyachessItemNo.item34,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_f,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item35]: {
    itemId: JoyachessItemNo.item35,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_g,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item36]: {
    itemId: JoyachessItemNo.item36,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_h,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item37]: {
    itemId: JoyachessItemNo.item37,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_i,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item38]: {
    itemId: JoyachessItemNo.item38,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_j,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item39]: {
    itemId: JoyachessItemNo.item39,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_k,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item40]: {
    itemId: JoyachessItemNo.item40,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_l,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item41]: {
    itemId: JoyachessItemNo.item41,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_m,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item42]: {
    itemId: JoyachessItemNo.item42,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_n,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item43]: {
    itemId: JoyachessItemNo.item43,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_o,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item44]: {
    itemId: JoyachessItemNo.item44,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_p,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item45]: {
    itemId: JoyachessItemNo.item45,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_q,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item46]: {
    itemId: JoyachessItemNo.item46,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_r,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item47]: {
    itemId: JoyachessItemNo.item47,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_s,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item48]: {
    itemId: JoyachessItemNo.item48,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_t,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item49]: {
    itemId: JoyachessItemNo.item49,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_u,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item50]: {
    itemId: JoyachessItemNo.item50,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_v,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item51]: {
    itemId: JoyachessItemNo.item51,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_w,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item52]: {
    itemId: JoyachessItemNo.item52,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_x,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item53]: {
    itemId: JoyachessItemNo.item53,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_y,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item54]: {
    itemId: JoyachessItemNo.item54,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_upperalphabet_z,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item55]: {
    itemId: JoyachessItemNo.item55,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_0,
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item56]: {
    itemId: JoyachessItemNo.item56,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_0,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item57]: {
    itemId: JoyachessItemNo.item57,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_1,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item58]: {
    itemId: JoyachessItemNo.item58,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_2,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item59]: {
    itemId: JoyachessItemNo.item59,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_3,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item60]: {
    itemId: JoyachessItemNo.item60,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_4,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item61]: {
    itemId: JoyachessItemNo.item61,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_5,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item62]: {
    itemId: JoyachessItemNo.item62,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_6,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item63]: {
    itemId: JoyachessItemNo.item63,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_7,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item64]: {
    itemId: JoyachessItemNo.item64,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_8,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item65]: {
    itemId: JoyachessItemNo.item65,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_number_9,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item66]: {
    itemId: JoyachessItemNo.item66,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_001,
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item67]: {
    itemId: JoyachessItemNo.item67,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_001,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item68]: {
    itemId: JoyachessItemNo.item68,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_002,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item69]: {
    itemId: JoyachessItemNo.item69,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_003,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item70]: {
    itemId: JoyachessItemNo.item70,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_004,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item71]: {
    itemId: JoyachessItemNo.item71,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_005,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item72]: {
    itemId: JoyachessItemNo.item72,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_006,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item73]: {
    itemId: JoyachessItemNo.item73,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_007,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item74]: {
    itemId: JoyachessItemNo.item74,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_008,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item75]: {
    itemId: JoyachessItemNo.item75,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_009,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item76]: {
    itemId: JoyachessItemNo.item76,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_010,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item77]: {
    itemId: JoyachessItemNo.item77,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_011,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item78]: {
    itemId: JoyachessItemNo.item78,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_012,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item79]: {
    itemId: JoyachessItemNo.item79,
    isVisible: false,
    visual: {
      filePrefix: entertainment_singlepiecechess_symbol_013,
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  //
  [JoyachessItemNo.item80]: {
    itemId: JoyachessItemNo.item80,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_diy,
      faction: {
        [GameFactionSide.Blue]:
          entertainment_singlepiecechess_emoji_0001_diy_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_diy_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_diy_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_diy_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item81]: {
    itemId: JoyachessItemNo.item81,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_01,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_01_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_01_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_01_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_01_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item82]: {
    itemId: JoyachessItemNo.item82,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_02,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_02_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_02_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_02_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_02_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item83]: {
    itemId: JoyachessItemNo.item83,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_03,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_03_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_03_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_03_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_03_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item84]: {
    itemId: JoyachessItemNo.item84,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_04,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_04_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_04_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_04_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_04_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item85]: {
    itemId: JoyachessItemNo.item85,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_05,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_05_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_05_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_05_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_05_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item86]: {
    itemId: JoyachessItemNo.item86,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_06,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_06_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_06_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_06_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_06_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item87]: {
    itemId: JoyachessItemNo.item87,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_07,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_07_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_07_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_07_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_07_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item88]: {
    itemId: JoyachessItemNo.item88,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_08,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_08_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_08_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_08_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_08_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item89]: {
    itemId: JoyachessItemNo.item89,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_09,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_09_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_09_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_09_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_09_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item90]: {
    itemId: JoyachessItemNo.item90,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_10,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_10_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_10_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_10_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_10_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item91]: {
    itemId: JoyachessItemNo.item91,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_11,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_11_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_11_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_11_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_11_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item92]: {
    itemId: JoyachessItemNo.item92,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0001_12,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0001_12_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0001_12_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0001_12_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0001_12_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item93]: {
    itemId: JoyachessItemNo.item93,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_diy,
      faction: {
        [GameFactionSide.Blue]:
          entertainment_singlepiecechess_emoji_0002_diy_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_diy_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_diy_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_diy_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item94]: {
    itemId: JoyachessItemNo.item94,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_01,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_01_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_01_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_01_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_01_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item95]: {
    itemId: JoyachessItemNo.item95,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_02,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_02_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_02_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_02_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_02_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item96]: {
    itemId: JoyachessItemNo.item96,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_03,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_03_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_03_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_03_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_03_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item97]: {
    itemId: JoyachessItemNo.item97,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_04,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_04_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_04_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_04_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_04_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item98]: {
    itemId: JoyachessItemNo.item98,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_05,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_05_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_05_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_05_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_05_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item99]: {
    itemId: JoyachessItemNo.item99,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_06,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_06_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_06_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_06_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_06_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item100]: {
    itemId: JoyachessItemNo.item100,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_07,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_07_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_07_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_07_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_07_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item101]: {
    itemId: JoyachessItemNo.item101,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_08,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_08_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_08_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_08_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_08_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item102]: {
    itemId: JoyachessItemNo.item102,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_09,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_09_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_09_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_09_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_09_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item103]: {
    itemId: JoyachessItemNo.item103,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_10,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_10_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_10_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_10_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_10_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item104]: {
    itemId: JoyachessItemNo.item104,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_11,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_11_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_11_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_11_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_11_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item105]: {
    itemId: JoyachessItemNo.item105,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_emoji_0002_12,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_emoji_0002_12_bl,
        [GameFactionSide.Purple]:
          entertainment_singlepiecechess_emoji_0002_12_pu,
        [GameFactionSide.Green]:
          entertainment_singlepiecechess_emoji_0002_12_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_emoji_0002_12_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item106]: {
    itemId: JoyachessItemNo.item106,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00001,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00001_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00001_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00001_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00001_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item107]: {
    itemId: JoyachessItemNo.item107,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00001,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00001_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00001_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00001_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00001_rd,
      },

      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item108]: {
    itemId: JoyachessItemNo.item108,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00002,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00002_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00002_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00002_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00002_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item109]: {
    itemId: JoyachessItemNo.item109,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00003,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00003_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00003_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00003_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00003_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item110]: {
    itemId: JoyachessItemNo.item110,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00004,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00004_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00004_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00004_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00004_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item111]: {
    itemId: JoyachessItemNo.item111,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00005,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00005_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00005_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00005_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00005_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item112]: {
    itemId: JoyachessItemNo.item112,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00006,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00006_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00006_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00006_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00006_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item113]: {
    itemId: JoyachessItemNo.item113,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00007,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00007_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00007_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00007_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00007_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item114]: {
    itemId: JoyachessItemNo.item114,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00008,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00008_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00008_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00008_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00008_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item115]: {
    itemId: JoyachessItemNo.item115,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00009,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00009_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00009_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00009_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00009_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item116]: {
    itemId: JoyachessItemNo.item116,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00002,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00002_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00002_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00002_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00002_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item117]: {
    itemId: JoyachessItemNo.item117,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00010,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00010_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00010_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00010_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00010_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item118]: {
    itemId: JoyachessItemNo.item118,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00011,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00011_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00011_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00011_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00011_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item119]: {
    itemId: JoyachessItemNo.item119,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00012,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00012_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00012_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00012_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00012_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item120]: {
    itemId: JoyachessItemNo.item120,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00013,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00013_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00013_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00013_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00013_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item121]: {
    itemId: JoyachessItemNo.item121,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00014,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00014_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00014_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00014_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00014_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item122]: {
    itemId: JoyachessItemNo.item122,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00015,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00015_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00015_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00015_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00015_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item123]: {
    itemId: JoyachessItemNo.item123,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00016,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00016_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00016_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00016_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00016_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item124]: {
    itemId: JoyachessItemNo.item124,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00017,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00017_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00017_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00017_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00017_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item125]: {
    itemId: JoyachessItemNo.item125,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00018,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00018_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00018_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00018_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00018_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item126]: {
    itemId: JoyachessItemNo.item126,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00003,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00003_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00003_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00003_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00003_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item127]: {
    itemId: JoyachessItemNo.item127,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00019,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00019_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00019_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00019_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00019_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item128]: {
    itemId: JoyachessItemNo.item128,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00020,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00020_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00020_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00020_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00020_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item129]: {
    itemId: JoyachessItemNo.item129,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00021,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00021_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00021_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00021_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00021_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item130]: {
    itemId: JoyachessItemNo.item130,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00022,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00022_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00022_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00022_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00022_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item131]: {
    itemId: JoyachessItemNo.item131,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00023,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00023_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00023_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00023_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00023_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item132]: {
    itemId: JoyachessItemNo.item132,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00024,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00024_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00024_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00024_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00024_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item133]: {
    itemId: JoyachessItemNo.item133,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00025,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00025_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00025_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00025_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00025_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item134]: {
    itemId: JoyachessItemNo.item134,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00026,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00026_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00026_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00026_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00026_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item135]: {
    itemId: JoyachessItemNo.item135,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00027,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00027_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00027_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00027_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00027_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item136]: {
    itemId: JoyachessItemNo.item136,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00004,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00004_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00004_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00004_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00004_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item137]: {
    itemId: JoyachessItemNo.item137,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00028,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00028_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00028_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00028_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00028_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item138]: {
    itemId: JoyachessItemNo.item138,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00029,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00029_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00029_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00029_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00029_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item139]: {
    itemId: JoyachessItemNo.item139,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00030,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00030_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00030_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00030_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00030_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item140]: {
    itemId: JoyachessItemNo.item140,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00031,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00031_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00031_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00031_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00031_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item141]: {
    itemId: JoyachessItemNo.item141,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00032,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00032_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00032_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00032_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00032_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item142]: {
    itemId: JoyachessItemNo.item142,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00033,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00033_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00033_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00033_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00033_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item143]: {
    itemId: JoyachessItemNo.item143,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00034,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00034_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00034_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00034_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00034_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item144]: {
    itemId: JoyachessItemNo.item144,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00035,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00035_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00035_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00035_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00035_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item145]: {
    itemId: JoyachessItemNo.item145,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00036,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00036_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00036_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00036_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00036_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item146]: {
    itemId: JoyachessItemNo.item146,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00005,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00005_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00005_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00005_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00005_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item147]: {
    itemId: JoyachessItemNo.item147,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00037,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00037_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00037_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00037_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00037_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item148]: {
    itemId: JoyachessItemNo.item148,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00038,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00038_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00038_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00038_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00038_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item149]: {
    itemId: JoyachessItemNo.item149,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00039,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00039_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00039_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00039_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00039_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item150]: {
    itemId: JoyachessItemNo.item150,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00040,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00040_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00040_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00040_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00040_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item151]: {
    itemId: JoyachessItemNo.item151,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00041,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00041_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00041_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00041_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00041_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item152]: {
    itemId: JoyachessItemNo.item152,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00042,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00042_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00042_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00042_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00042_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item153]: {
    itemId: JoyachessItemNo.item153,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00043,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00043_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00043_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00043_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00043_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item154]: {
    itemId: JoyachessItemNo.item154,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00044,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00044_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00044_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00044_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00044_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item155]: {
    itemId: JoyachessItemNo.item155,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00045,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00045_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00045_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00045_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00045_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item156]: {
    itemId: JoyachessItemNo.item156,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00006,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00006_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00006_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00006_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00006_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item157]: {
    itemId: JoyachessItemNo.item157,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00046,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00046_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00046_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00046_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00046_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item158]: {
    itemId: JoyachessItemNo.item158,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00047,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00047_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00047_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00047_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00047_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item159]: {
    itemId: JoyachessItemNo.item159,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00048,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00048_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00048_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00048_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00048_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item160]: {
    itemId: JoyachessItemNo.item160,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00049,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00049_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00049_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00049_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00049_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item161]: {
    itemId: JoyachessItemNo.item161,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00050,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00050_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00050_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00050_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00050_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item162]: {
    itemId: JoyachessItemNo.item162,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00051,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00051_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00051_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00051_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00051_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item163]: {
    itemId: JoyachessItemNo.item163,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00052,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00052_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00052_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00052_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00052_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item164]: {
    itemId: JoyachessItemNo.item164,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00053,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00053_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00053_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00053_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00053_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item165]: {
    itemId: JoyachessItemNo.item165,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00054,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00054_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00054_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00054_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00054_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item166]: {
    itemId: JoyachessItemNo.item166,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00007,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00007_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00007_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00007_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00007_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item167]: {
    itemId: JoyachessItemNo.item167,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00055,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00055_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00055_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00055_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00055_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item168]: {
    itemId: JoyachessItemNo.item168,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00056,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00056_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00056_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00056_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00056_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item169]: {
    itemId: JoyachessItemNo.item169,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00057,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00057_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00057_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00057_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00057_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item170]: {
    itemId: JoyachessItemNo.item170,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00058,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00058_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00058_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00058_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00058_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item171]: {
    itemId: JoyachessItemNo.item171,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00059,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00059_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00059_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00059_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00059_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item172]: {
    itemId: JoyachessItemNo.item172,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00060,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00060_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00060_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00060_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00060_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item173]: {
    itemId: JoyachessItemNo.item173,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00061,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00061_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00061_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00061_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00061_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item174]: {
    itemId: JoyachessItemNo.item174,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00062,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00062_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00062_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00062_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00062_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item175]: {
    itemId: JoyachessItemNo.item175,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00063,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00063_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00063_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00063_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00063_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item176]: {
    itemId: JoyachessItemNo.item176,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_diy_00008,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_diy_00008_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_diy_00008_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_diy_00008_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_diy_00008_rd,
      },
      hasThumbnail: false,
      hasMask: true,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item177]: {
    itemId: JoyachessItemNo.item177,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00064,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00064_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00064_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00064_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00064_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item178]: {
    itemId: JoyachessItemNo.item178,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00065,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00065_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00065_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00065_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00065_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item179]: {
    itemId: JoyachessItemNo.item179,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00066,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00066_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00066_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00066_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00066_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item180]: {
    itemId: JoyachessItemNo.item180,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00067,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00067_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00067_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00067_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00067_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item181]: {
    itemId: JoyachessItemNo.item181,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00068,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00068_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00068_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00068_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00068_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item182]: {
    itemId: JoyachessItemNo.item182,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00069,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00069_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00069_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00069_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00069_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item183]: {
    itemId: JoyachessItemNo.item183,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00070,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00070_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00070_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00070_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00070_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item184]: {
    itemId: JoyachessItemNo.item184,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00071,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00071_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00071_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00071_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00071_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
  [JoyachessItemNo.item185]: {
    itemId: JoyachessItemNo.item185,
    isVisible: true,
    visual: {
      filePrefix: entertainment_singlepiecechess_00072,
      faction: {
        [GameFactionSide.Blue]: entertainment_singlepiecechess_00072_bl,
        [GameFactionSide.Purple]: entertainment_singlepiecechess_00072_pu,
        [GameFactionSide.Green]: entertainment_singlepiecechess_00072_gn,
        [GameFactionSide.Red]: entertainment_singlepiecechess_00072_rd,
      },
      hasThumbnail: false,
      hasMask: false,
      hasHighlight: false,
    },
    strokeColor: undefined,
  },
};

export function getChessItemByJoyachessItemNo(
  itemId: JoyachessItemNo,
): ChessItem | undefined {
  return joyachessMaps[itemId];
}
